import { CardTypeCallToActions, RouteTypes } from '@app/enums/_index';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { StaticPageService } from '@app/services/_index';
import { StaticPage } from '@app/models/_index';
import { StaticPageAdapter } from '@app/adapters/_index';
import { StaticPageInterface } from '@app/interfaces/_index';
import { Subscription } from 'rxjs';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-pointillist-detail',
  templateUrl: './pointillist-detail.component.html',
  styleUrls: ['./pointillist-detail.component.scss'],
  standalone: false,
})
export class PointillistDetailComponent implements OnInit, OnDestroy {
  @Input() name: string;
  sub: Subscription;
  isLoading: boolean;
  contentData: StaticPage;
  images = [];
  showPointillistCMSContent = environment.beyond.pointillist.featureFlags.showCMSContent;
  showPointillistDetailHeroBanner =
    environment.beyond.pointillist.featureFlags.showPointillistDetailHeroBanner;

  constructor(
    private staticPageService: StaticPageService,
    private staticPageAdapter: StaticPageAdapter
  ) {}

  /**
   * OnInit load page
   */
  ngOnInit(): void {
    this.getSingleTypePage(this.name);
  }

  /**
   * OnDestroy unsubcribe BeyondCX testimonials to prevent memory leaks
   */
  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  /**
   * Load BeyondCX Single Page content from WordPress
   */
  getSingleTypePage(slug: string): void {
    this.isLoading = true;
    this.sub = this.staticPageService.getStaticPageDetail(slug).subscribe({
      next: (response: StaticPageInterface[]) => {
        if (response && response.length > 0) {
          response.filter((item: StaticPageInterface) => {
            // NOTE: The WordPress Slugified slug (based on page name) should match and
            // return one result
            if (item.slug === this.name) {
              this.contentData = this.staticPageAdapter.adapt(item);
            }
          });
        }
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        console.log(error);
      },
      complete: () => {
        // Force is loading to stop and complete in case of any unhandled errors
        this.isLoading = false;
        console.log('Pointillist content completed');
      },
    });
  }

  /**
   *  RouteTypes enums based on route types
   */
  public get routeTypes(): typeof RouteTypes {
    return RouteTypes;
  }

  /**
   *  CardTypeCallToActions enums based on card types
   */
  public get cardTypeCallToActions(): typeof CardTypeCallToActions {
    return CardTypeCallToActions;
  }
}
